import script from "./LegacyDropdownMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./LegacyDropdownMenu.vue?vue&type=script&setup=true&lang=js"

import "./LegacyDropdownMenu.vue?vue&type=style&index=0&id=8ed58aea&lang=scss"

const __exports__ = script;

export default __exports__